import CustomEditor from "./Component/CustomEditor";

function App() {
  return (
    <div className="App" style={{width: "90%"}}>
      <div style={{display:"flex", alignItems: "center", justifyContent:"center"}}>
      <img src="https://cdn-icons-png.flaticon.com/512/2535/2535559.png" height="60px" alt="logo"></img>
      <h1 style={{marginLeft: "20px"}}>Custom Text Editor</h1>
      </div>
      <CustomEditor />
    </div>
  ); 
}

export default App;
